import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import RightArrowIcon from '../../../icons/RightArrowIcon.jsx';
import styles from './InitiativeCounts.module.css';

InitiativeCounts.propTypes = {
  initiativesHidden: PropTypes.bool.isRequired,
  communicationCount: PropTypes.number.isRequired,
  readinessCount: PropTypes.number.isRequired,
  trainingCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

function InitiativeCounts({
  initiativesHidden,
  communicationCount,
  readinessCount,
  trainingCount,
  sustainmentCount,
  onClick,
}) {
  const totalCount =
    communicationCount + readinessCount + trainingCount + sustainmentCount;

  const className = classNames(styles.initiativeCounts, {
    [styles.initiativesHidden]: initiativesHidden,
  });

  return (
    <div className="flex">
      <span
        role={'button'}
        className={className}
        onClick={onClick}
        title={`${initiativesHidden ? 'Show' : 'Hide'} Initiatives`}
      >
        <RightArrowIcon />
        <span>{communicationCount} Communication</span>
        <span>{readinessCount} Readiness</span>
        <span>{trainingCount} Training</span>
        <span>{sustainmentCount} Sustainment</span>
        <span className="text-muted">&bull;</span>
        <strong>{totalCount} Total</strong>
      </span>
    </div>
  );
}

export default InitiativeCounts;
